import React from 'react';
import { useSharedPluginState, sharedPluginStateHookMigratorFactory, useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { ToolbarType } from '../types';

// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
import ToolbarTextColor from './ToolbarTextColor';
var useSharedState = sharedPluginStateHookMigratorFactory(function (api) {
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['textColor'], function (states) {
      var _states$textColorStat, _states$textColorStat2, _states$textColorStat3, _states$textColorStat4;
      return {
        color: (_states$textColorStat = states.textColorState) === null || _states$textColorStat === void 0 ? void 0 : _states$textColorStat.color,
        defaultColor: (_states$textColorStat2 = states.textColorState) === null || _states$textColorStat2 === void 0 ? void 0 : _states$textColorStat2.defaultColor,
        palette: (_states$textColorStat3 = states.textColorState) === null || _states$textColorStat3 === void 0 ? void 0 : _states$textColorStat3.palette,
        disabled: (_states$textColorStat4 = states.textColorState) === null || _states$textColorStat4 === void 0 ? void 0 : _states$textColorStat4.disabled
      };
    }),
    color = _useSharedPluginState.color,
    defaultColor = _useSharedPluginState.defaultColor,
    palette = _useSharedPluginState.palette,
    disabled = _useSharedPluginState.disabled;
  return {
    color: color,
    defaultColor: defaultColor,
    palette: palette,
    textColorDisabled: disabled
  };
}, function (api) {
  var _useSharedPluginState2 = useSharedPluginState(api, ['textColor']),
    textColorState = _useSharedPluginState2.textColorState;
  return {
    color: textColorState === null || textColorState === void 0 ? void 0 : textColorState.color,
    defaultColor: textColorState === null || textColorState === void 0 ? void 0 : textColorState.defaultColor,
    palette: textColorState === null || textColorState === void 0 ? void 0 : textColorState.palette,
    textColorDisabled: textColorState === null || textColorState === void 0 ? void 0 : textColorState.disabled
  };
});
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    isReducedSpacing = _ref.isReducedSpacing,
    editorView = _ref.editorView,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent,
    disabled = _ref.disabled;
  var _useSharedState = useSharedState(api),
    color = _useSharedState.color,
    defaultColor = _useSharedState.defaultColor,
    palette = _useSharedState.palette,
    textColorDisabled = _useSharedState.textColorDisabled;
  if (color === undefined || defaultColor === undefined || palette === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ToolbarTextColor, {
    pluginState: {
      color: color,
      defaultColor: defaultColor,
      palette: palette,
      disabled: textColorDisabled
    },
    isReducedSpacing: isReducedSpacing,
    editorView: editorView,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
    disabled: disabled,
    pluginInjectionApi: api,
    toolbarType: ToolbarType.PRIMARY
  });
}